module.exports = __webpack_public_path__ + "static/media/sws-pdf.f44bbf01.svg";